// https://apps.dealercenter-np.coxautoinc.com/landing/public/modals
// eslint-disable-next-line no-restricted-imports
import type { Anchor } from "@interstate/components/SlideOut/Types/slideOutTypes";
import type { ModalSizes } from "@dealer-center/core-components";
import {
  Button,
  Grid,
  Modal,
  SelectInput,
  SlideOut,
  Typography
} from "@dealer-center/core-components";
import { useEffect, useState } from "react";
const ipsum = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat vitae sem eget eleifend. Vivamus ac velit laoreet, eleifend velit id, aliquam magna. Donec id est ex. Nulla id libero mi. Duis non nulla et velit dapibus sagittis. Maecenas maximus congue neque, non fringilla eros dapibus et. Nullam dictum scelerisque purus et imperdiet.

Duis quis iaculis odio, et varius orci. Suspendisse mi erat, commodo sit amet risus vel, gravida pretium neque. Proin venenatis, odio sit amet condimentum egestas, dui tortor commodo quam, ut efficitur lorem metus eu massa. Nulla facilisi. Proin cursus, nisl eu sagittis viverra, purus odio convallis ipsum, sit amet viverra ipsum augue at est. In hac habitasse platea dictumst. Donec faucibus est dui, in hendrerit velit convallis eu. Vivamus pulvinar vestibulum tortor, ac dictum nisl posuere at. Nulla vitae scelerisque erat. In convallis congue nunc quis facilisis. Praesent nisi ligula, euismod ut neque ac, ultricies sodales nibh. Etiam in velit sit amet urna tempus suscipit id quis ipsum. Nulla quis ligula vestibulum, efficitur dui non, pharetra urna.

Suspendisse sagittis eu augue quis aliquam. Sed eget est quis quam venenatis aliquet. Phasellus aliquet neque ut ex congue tristique. Etiam id vehicula lectus, et suscipit enim. Maecenas sit amet euismod metus, ac pellentesque neque. Integer tristique erat nulla, id sollicitudin elit iaculis sed. Vivamus nec sem augue. Cras vel augue id magna pellentesque auctor. Fusce vel congue tortor. Maecenas id lectus vel sapien semper rhoncus ac auctor sapien. Proin eget varius ante. Fusce hendrerit facilisis velit sit amet dapibus. Nulla rhoncus sodales mattis. Nulla eget tortor nec neque condimentum semper. Quisque venenatis leo ac risus feugiat, a efficitur nulla volutpat.

Donec tempor euismod accumsan. Duis odio elit, pellentesque et placerat in, ornare mattis nulla. Praesent bibendum velit nulla, id tincidunt est blandit eu. Aenean vitae suscipit metus. Curabitur ut enim lobortis elit dignissim sodales. Fusce elementum nibh magna, eget convallis sem scelerisque et. Aliquam vel ex dapibus diam interdum elementum. Cras sagittis pellentesque orci. Morbi ultrices, ligula sed volutpat malesuada, lectus est blandit ligula, non faucibus tellus nulla id nunc. Aenean porta sed leo et tincidunt. Cras vehicula sem vel diam placerat gravida.

Duis nec eros a nunc sodales ultricies. In eleifend, enim nec gravida accumsan, nulla eros consectetur mi, eget efficitur ante nulla congue orci. Donec eu risus fringilla, imperdiet turpis quis, gravida felis. Duis tristique diam et ante convallis, id volutpat dui tincidunt. Nullam at libero risus. In ultricies, neque vitae aliquet hendrerit, augue nulla vestibulum massa, eu varius est justo eget neque. Phasellus eu lacinia dolor. Quisque pretium, enim eget semper consequat, lectus libero bibendum nulla, eget vehicula enim tellus id neque. Morbi ut sollicitudin quam. Nulla semper molestie nibh eget gravida. Sed ullamcorper blandit elit et mollis. Integer sit amet justo sed lorem dictum dignissim.`;
export const ModalsTest = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalSize, setModalSize] = useState<ModalSizes>("small");
  const [showSlideout, setShowSlideout] = useState(false);
  const [slideOutPosition, setSlideOutPosition] = useState<Anchor>("left");
  useEffect(() => {
    document.title = "Modals Test";
  });
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h1">Modals Test</Typography>
      </Grid>
      <Grid>
        <Typography variant="h2">Modals</Typography>
        <SelectInput
          label="Modal Size"
          options={[
            { label: "Small", value: "small" },
            { label: "fullScreen", value: "fullScreen" },
            { label: "Large", value: "large" }
          ]}
          onChange={e => setModalSize(e.target.value as ModalSizes)}
        />
        <Button
          analyticsConfiguration={{
            eventName: "Show Modal"
          }}
          onClick={() => setShowModal(true)}
        >
          Show Modal
        </Button>
        <Modal
          show={showModal}
          size={modalSize}
          onHide={() => setShowModal(false)}
        >
          <Typography variant="h2">Modal Content</Typography>
          <Typography variant="body-lg">{ipsum}</Typography>
        </Modal>
      </Grid>
      <Grid>
        <Typography variant="h2">SlideOut</Typography>
        <SelectInput
          label="SlideOut Position"
          options={[
            { label: "Left", value: "left" },
            { label: "Right", value: "right" },
            { label: "Top", value: "top" },
            { label: "Bottom", value: "bottom" }
          ]}
          onChange={e => setSlideOutPosition(e.target.value as Anchor)}
        />
        <Button
          analyticsConfiguration={{
            eventName: "Show SlideOut"
          }}
          onClick={() => setShowSlideout(true)}
        >
          Show SlideOut
        </Button>
        <SlideOut
          hasBridgeBar={false}
          position={slideOutPosition}
          show={showSlideout}
          onHide={() => setShowSlideout(false)}
        >
          <Typography variant="h2">SlideOut Content</Typography>
          <Typography variant="body-lg">{ipsum}</Typography>
        </SlideOut>
      </Grid>
    </Grid>
  );
};
